import React, { useContext } from 'react';
import { Segment, Button, Header, Icon } from 'semantic-ui-react';
import { RootStoreContext } from '../../app/stores/rootStore';

const NotFound = () => {
    const rootStore = useContext(RootStoreContext);
    const { logout } = rootStore.userStore;
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
                Oops - your session has been expired!
            </Header>
            <Segment.Inline>
                <Button onClick={logout} text='Logout' primary>
                Return to login page
                </Button>
            </Segment.Inline>
        </Segment>
    );
};

export default NotFound;